var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap align-items-center list-user-action",staticStyle:{"gap":"3px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }